import { FaInstagram } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";
import './header.css';
import 'bootstrap/dist/css/bootstrap.css';
import { Link } from 'react-router-dom';
import { useState } from "react";

function Header({ dpdwn, setDpdwn }) {

  const [fack, setFack] = useState(false)

  return (
    <div><div className="upper">
      {/* <a href="https://www.instagram.com/dojma_bitsgoa/?hl=en"
        className="DojmaSocial2" target="blank">
        <FaInstagram className="DojmaSocial22"/>
      </a> */}

      <Link className='BitsHerald' to='/'>
        The BITS Herald
      </Link>


      {/* <Link to='/login' className="DojmaSocial1" >
      <CgProfile className="DojmaSocial11" />
    </Link> */}

    </div>

      <div className="creditsur">BY THE STUDENTS OF BITS GOA</div>
      <div className="navbarium" style={{ position: "relative" }}>
        <Link to="/" className="navbaritems">HOME</Link>
        <Link to="/all_articles" className="navbaritems">ARTICLES</Link>

        <Link to="/about_us" className="navbaritems">ABOUT US</Link>
        <div><button className="navbaritems butbun" onClick={() => { setFack(fack ? false : true); setDpdwn(dpdwn ? false : true) }}>ELECTIONS{!fack ? <MdKeyboardArrowDown size={25} /> : <MdKeyboardArrowUp size={25} />}</button></div>
        <Link to="https://forms.gle/bg4yYCAFdkA86dg3A" target="_blank" className="navbaritems special">SUBMIT TIP</Link>
        {dpdwn && (
          <div className="drpdwn">
            <Link to="/acadassoc_cs" state={{ year: 2025 }} onClick={() => { setDpdwn(false) }} className="dlinks">AcadAssoc '25</Link>
            <Link to="/csaelection_pres" state={{ year: 2025 }} onClick={() => { setDpdwn(false) }} className="dlinks">CSA '25</Link>
            {/* <Link to="/acadassoc_cs" state={{ year: 2026 }} onClick={() => { setDpdwn(false) }} className="dlinks">
              acadassoc '26
            </Link> */}
            <Link to="/csaelection_pres" state={{ year: 2026 }} onClick={() => { setDpdwn(false) }} className="dlinks">
              CSA '26
            </Link>

          </div>
        )}
      </div>


    </div>
  );
}

export default Header;
